/*
 * Image Gallery Video Theme Styles
 */
export default {
    baseStyle: {
        container: {
            position: 'relative',
            width: '100%',
            height: '100%'
        },

        spinnerWrapper: {
            position: 'absolute',
            inset: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 3,
            pointerEvents: 'none'
        },

        spinnerBackdrop: {
            position: 'absolute',
            inset: 0,
            backgroundColor: 'rgba(255, 255, 255, 0.2)',
            backdropFilter: 'blur(8px)',
            WebkitBackdropFilter: 'blur(8px)'
        },

        spinner: {
            position: 'relative',
            zIndex: 1,
            display: 'block',
            width: '40px',
            height: '40px',
            borderRadius: 'full',
            border: '3px solid rgba(0, 0, 0, 0.12)',
            borderTopColor: 'gray.800'
        },

        videoWrapper: {
            position: 'absolute',
            inset: 0,
            zIndex: 2,
            transition: 'opacity 0.4s ease'
        }
    },

    parts: [
        'container',
        'spinnerWrapper',
        'spinnerBackdrop',
        'spinner',
        'videoWrapper'
    ]
}